<template>
  <div class="row align-items-center justify-content-between mt-1">
    <div class="col-auto">
      <h5 class=" text-blue fw-700 fw-bolder mb-0">
        <span
          v-if="showBullet"
          class="rounded-circle bg-primary d-inline-block"
          style="height: 9px; width: 9px;"
        ></span>
        {{ objKey }}
      </h5>
    </div>
    <div class="col-auto">
      <h5 class=" text-blue fw-700 fw-bolder mb-0">
        <span v-if="showCurrency">&#8358;</span>{{ objValue
        }}<span v-if="showPercent">%</span>
      </h5>
    </div>
  </div>
</template>

<script>
export default {
  name: "KeyValue",
  props: {
    showBullet: {
      type: Boolean,
      default: false
    },
    objKey: String,
    objValue: [String, Number],
    showCurrency: {
      type: Boolean,
      default: false
    },
    showPercent: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped></style>
